<template>
<div>
    <div class="form-container ou-donation-form" id="elm">
      <div class="holder ncsyupseell">
        <PaymentForm class="form-horizontal" @submit.prevent="doUpsell">

                <FormSection title="Your Sponsorship">
                    <div>
                        <AmountSelectorTishabeav/>
                        <ErrorLabel field="amount" />
                    </div>

                    <TishaBavUpsell @close="submit" v-if="showUpsell" />

                  <InHonorOf/>
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>

                <FormSection title="Personal Information">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Submit Sponsorship" @click.prevent="doUpsell"/>
              </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { ref } from "vue";

import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { setValue, form, getValue, submit } = usePaymentForm();

    const showUpsell = ref(false);

    return {
      form,
      submit,
      getValue,
      setValue,
      showUpsell,
      doUpsell() {
        const shouldShowUpsell =
          !!form.value.amount &&
          parseInt(form.value.amount) > 0;

        showUpsell.value = shouldShowUpsell;

        if (!showUpsell.value) {
          submit();
        }
      },
    }
  },
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right:5px;
}
::v-deep .radio-part {
    min-width: 31.33333% !important;
    max-width: 31.33333% !important;
    &:nth-child(6n) {
      padding-right: 10px !important;
    }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount-row label {
  padding-top:0;
  padding-bottom:0;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount-row:not([data-amount="5000"]) {
  min-width:31.333% !important;
  max-width:31.333% !important;
  .label-amount {
    max-width: 100%;
    min-width: 100%;
  }
}
.ncsyupseell {
  position: relative;
}
::v-deep span.flex > span {
    display: flex;
}

</style>

